// @flow

export const diagnosticsLatestLoad = (domainId: number) => ({
    type: 'DIAGNOSTICS_LATEST_LOAD',
    payload: { domainId },
});

export const diagnosticsStart = (domainId: number) => ({
    type: 'DIAGNOSTICS_START',
    payload: { domainId },
});

export const diagnosticsStarted = (domainId: number, report: Object) => ({
    type: 'DIAGNOSTICS_STARTED',
    payload: { domainId, report },
});

export const diagnosticsLoaded = (domainId: number, report: Object) => ({
    type: 'DIAGNOSTICS_LOADED',
    payload: { domainId, report },
});

export const diagnosticsLatestMissing = (domainId: number) => ({
    type: 'DIAGNOSTICS_LATEST_MISSING',
    payload: { domainId },
});

export const diagnosticsFailed = (domainId: number, error: Object) => ({
    type: 'DIAGNOSTICS_FAILED',
    payload: { domainId, error },
});

export const diagnosticsStop = (domainId: number) => ({
    type: 'DIAGNOSTICS_STOP',
    payload: { domainId },
});
